export default "__VITE_ASSET__BAL_5mAx__"